import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
// import moment from 'moment';

import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';

import HardwareList from '../../HardwareList';
import Dropzone from '../../../../../shared/dropzone/Dropzone';
import RestrictComponent from '../../../../../shared/RestrictComponent';

import { simpleUpdateCase } from '../../../../../../actions/casesActions';

import { userRoles } from '../../../../../../constants';
// import { caseConstants } from '../../../../../../constants';

// const { fileTypes } = caseConstants;

const CmfStep5Static = (props) => {
  const {
    hardware,
    notes,
    surgicalInfo,
    userRole,
    updateCase,
    products,
    activeCase,
    updateCaseFiles,
    userId,
  } = props;

  const theme = useTheme();
  const primaryStyle = { color: theme.palette.primary.main };

  const {
    GLOBAL_ADMIN,
    COUNTRY_ADMIN,
    DISTRIBUTOR_ADMIN,
    SURGEON,
    ENGINEER,
    SALES_REP,
    LOGISTICS,
    PRACTICE_MANAGER,
    MANUFACTURER,
  } = userRoles;

  const { maxilla, leftMandible, rightMandible, genioplasty } = activeCase;

  const initialHardwareList = maxilla ? maxilla.map((item) => ({ ...item, id: Math.random() * Math.random() })) : [];
  const initialLeftMandibleList = leftMandible
    ? leftMandible.map((item) => ({ ...item, id: Math.random() * Math.random() }))
    : [];
  const initialRightMandibleList = rightMandible
    ? rightMandible.map((item) => ({ ...item, id: Math.random() * Math.random() }))
    : [];
  const initialGenioplastyList = genioplasty
    ? genioplasty.map((item) => ({ ...item, id: Math.random() * Math.random() }))
    : [];

  const [maxillaList, setMaxillaList] = useState(initialHardwareList);
  const [leftMandibleList, setLeftMandibleList] = useState(initialLeftMandibleList);
  const [rightMandibleList, setRightMandibleList] = useState(initialRightMandibleList);
  const [genioplastyList, setGenioplastyList] = useState(initialGenioplastyList);

  const [isEditMode, setEditMode] = useState(false);
  const [isEditLeftMandibleMode, setEditLeftMandibleMode] = useState(false);
  const [isEditRightMandibleMode, setEditRightMandibleMode] = useState(false);
  const [isEditGenioplastyMode, setEditGenioplastyMode] = useState(false);
  const [isEditFilesMode, setEditFilesMode] = useState(false);

  const [sheets, setSheets] = useState([]);
  const [xRays, setXRays] = useState([]);
  const [aoas, setAoas] = useState([]);
  const [allografts, setAllografts] = useState([]);

  useEffect(() => {
    if (maxilla) {
      setMaxillaList(maxilla.map((item) => ({ ...item, id: Math.random() * Math.random() })));
    }
    if (leftMandible) {
      setLeftMandibleList(leftMandible.map((item) => ({ ...item, id: Math.random() * Math.random() })));
    }
    if (rightMandible) {
      setRightMandibleList(rightMandible.map((item) => ({ ...item, id: Math.random() * Math.random() })));
    }
    if (genioplasty) {
      setGenioplastyList(genioplasty.map((item) => ({ ...item, id: Math.random() * Math.random() })));
    }
  }, [maxilla, leftMandible, rightMandible, genioplasty]);

  const isPermission = !activeCase.trainingMode
    ? [GLOBAL_ADMIN, COUNTRY_ADMIN]
    : [
      GLOBAL_ADMIN,
      COUNTRY_ADMIN,
      DISTRIBUTOR_ADMIN,
      SURGEON,
      ENGINEER,
      SALES_REP,
      LOGISTICS,
      PRACTICE_MANAGER,
      MANUFACTURER,
    ];

  const onSave = () => {
    const updatedCase = {
      ...activeCase,
      maxilla: maxillaList.map((item) => ({
        product: item.product,
        amount: item.amount,
        category: item.category || '',
      })),
      leftMandible: leftMandibleList.map((item) => ({
        product: item.product,
        amount: item.amount,
        category: item.category || '',
      })),
      rightMandible: rightMandibleList.map((item) => ({
        product: item.product,
        amount: item.amount,
        category: item.category || '',
      })),
      genioplasty: genioplastyList.map((item) => ({
        product: item.product,
        amount: item.amount,
        category: item.category || '',
      })),
    };

    updateCase(updatedCase);
    setEditMode(false);
    setEditLeftMandibleMode(false);
    setEditRightMandibleMode(false);
    setEditGenioplastyMode(false);
  };

  return (
    <div className="case-static-container">
      <div className="p-b-md m-b-md underline">
        <div className="m-b-sm d-flex">
          <div className="secondary">MAXILLA</div>
          <RestrictComponent roles={isPermission}>
            {isEditMode ? (
              <div className="m-l-sm pointer" style={primaryStyle} onClick={onSave}>
                Save
              </div>
            ) : (
              <div className="m-l-sm pointer" style={primaryStyle} onClick={() => setEditMode(true)}>
                Edit
              </div>
            )}
          </RestrictComponent>
        </div>

        {isEditMode ? (
          <HardwareList
            hardwareList={maxillaList}
            products={products}
            onAdd={() => {}}
            onRemove={() => {}}
            onAmountChange={() => {}}
            onCategoryChange={() => {}}
            onChange={() => {}}
            procedureFlow={activeCase.procedureFlow}
          />
        ) : (
          maxillaList.map((item, index) => (
            <div key={`${index}-${item.product}`} className="d-flex">
              <div>
                {`${index + 1}.`} <span className="secondary">{item.category}</span> {item.product}
              </div>
              <div className="secondary m-l-sm">x {item.amount}</div>
            </div>
          ))
        )}
      </div>

      <div className="m-b-sm d-flex">
        <div className="secondary uppercase">Upload additional files</div>
        <RestrictComponent roles={isPermission}>
          {isEditFilesMode ? (
            <div className="m-l-sm pointer" style={primaryStyle} onClick={() => setEditFilesMode(false)}>
              Save
            </div>
          ) : (
            <div className="m-l-sm pointer" style={primaryStyle} onClick={() => setEditFilesMode(true)}>
              Edit
            </div>
          )}
        </RestrictComponent>
      </div>

      {isEditFilesMode && (
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Dropzone files={sheets} onUpload={() => {}} type="image" icon="image" />
          </Grid>
        </Grid>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  const activeCase = state.cases.activeCase;
  const procedure = state.procedures.list.find((p) => p.id === activeCase.procedure);
  const products = procedure ? procedure.products : [];

  return {
    notes: activeCase.notes && activeCase.notes.step10,
    surgicalInfo: activeCase.surgicalInfo,
    userRole: state.user.currentUser.role,
    userId: state.user.currentUser.uid,
    products,
    activeCase,
  };
};

const mapDispatchToProps = (dispatch) => ({
  updateCase: (updatedCase) => dispatch(simpleUpdateCase(updatedCase)),
  updateCaseFiles: (currCase, files) => dispatch(simpleUpdateCase(currCase, files)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CmfStep5Static);
